module.exports = __webpack_public_path__ + "media/images/ticket-outline-c24e692ffdb2ee51aa872d03d340c256.svg";